// MUI
import { makeStyles } from "@mui/styles";

// Constants
import {
  QESSupportDataLocalIdent,
  QESSupportDataRemoteIdent,
  SUPPORT_QES_LOCAL_IDENT,
} from "../../constants/ManualRequestFormConstants";

const useStyles = makeStyles(() => ({
  supportContainer: { width: "100%" },
  basketData: {
    overflow: "hidden",
    textAlign: "left",
    font: "normal normal medium 12px/20px Fira Sans",
    background: "#E6E6E64D 0% 0% no-repeat padding-box",
    borderRadius: "5px",
    opacity: 1,
    padding: "0.5rem 1rem",
    width: "100%",
    border: "2px solid #5F5F5F",
  },
  basketDataHeader: {
    color: "#5F5F5F",
    marginRight: "0.5rem",
    display: "inline-block",
    verticalAlign: "top",
    font: "normal normal normal 12px/20px Fira Sans;",
    textAlign: "left",
    letterSpacing: "0px",
    opacity: 1,
  },
  basketDataValue: {
    textAlign: "left",
    font: "normal normal medium 12px/20px Fira Sans",
    letterSpacing: "0px",
    color: "#5F5F5F",
    display: "inline-block",
    minWidth: "120px",
  },
  supportDetailSection: { display: "flex", alignItems: "center" },
}));

const QESSupportDataBox = ({ qesSupportData }) => {
  const classes = useStyles();
  const isLocalIdent = qesSupportData?.qesType === SUPPORT_QES_LOCAL_IDENT;

  return (
    <div className={classes.basketData}>
      <div className={classes.supportContainer}>
        {(isLocalIdent
          ? QESSupportDataLocalIdent
          : QESSupportDataRemoteIdent
        ).map((item) => (
          <div key={item.key} style={{ marginBottom: "0.3rem" }}>
            <div className={classes.supportDetailSection}>
              <span
                className={classes.basketDataHeader}
                style={{ minWidth: isLocalIdent ? "60px" : "90px" }}
              >
                {item?.label}:
              </span>
              <span className={classes.basketDataValue}>
                {qesSupportData?.[item.key] || ""}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default QESSupportDataBox;
